import React from 'react';
import { DetailSectionModularProps, mapDispatchToProps, mapStateToProps } from 'component/page/detail/DetailCard/DetailsCard.selectors';
import { Box, Divider, Image, TextLink } from '@drone-js/core';
import ScreenSize from 'component/common/Experiment/ScreenSize';
import { connect } from 'react-redux';
import {
    BookingCounterNodeComponent,
    HighlightBadgesNodeComponent,
    KeyAttributeBadgesNodeComponent,
    ReviewSummaryNodeComponent,
    SectionTitleComponent,
} from 'component/page/detail/DetailCard/DetailTitleSectionComponents';

const DetailTitleWithThumbnail: React.FC<DetailSectionModularProps> = (props) => {
    const { badges } = props;
    const shouldShowBadges = badges && badges.keyAttributes && badges.keyAttributes.length > 0;

    return (
        <Box display="flex" data-testid="details-card" flexDirection="column">
            <Box display="flex" flexDirection="row" alignItems="center" width="100%">
                <Box display="flex" flexDirection="column" flexGrow={1} flexShrink={1} flexBasis="0" alignSelf="start" pe="24">
                    <Box py="0">
                        <HighlightBadgesNodeComponent badges={badges} activityId={props.activityId} isPageContainerSpacing={props.pageContainerSpacing} />
                        <SectionTitleComponent isPageContainerSpacing={props.pageContainerSpacing} contentLocale={props.contentLocale} title={props.title} />
                        <Box display="flex" flexDirection="row" alignItems="center" mt="8" mb="12">
                            <ReviewSummaryNodeComponent
                                reviewTotalReview={props.reviewTotalReview}
                                reviewAverageScore={props.reviewAverageScore}
                                cms={props.cms}
                                contentLocale={props.contentLocale}
                                onSeeReviewClick={props.onSeeReviewClick}
                                variant={props.variant}
                            />
                            <BookingCounterNodeComponent badges={badges} reviewAverageScore={props.reviewAverageScore} reviewTotalReview={props.reviewTotalReview} />
                        </Box>
                    </Box>
                    <Box me="16">{props.screenSize.desktop && <Divider mt="0" dividerStyle="dashed" direction="horizontal" />}</Box>
                    <ScreenSize.Desktop condition={shouldShowBadges}>
                        <Box display="flex" mt="12" justifyContent="flex-start">
                            <KeyAttributeBadgesNodeComponent badges={badges} activityId={props.activityId} />
                        </Box>
                    </ScreenSize.Desktop>
                    {props.screenSize.desktop && (
                        <Box my="16">
                            <TextLink data-testid="activities-see-more-details" label={props.cms[411656]} textVariant="body-s" onClick={props.showSeeDetailsOverlay} />
                        </Box>
                    )}
                </Box>
                <Box
                    data-testid="main-image-container"
                    display="flex"
                    flexDirection="column"
                    width={props.screenSize.desktop ? '240px' : '64px'}
                    height={props.screenSize.desktop ? '140px' : '64px'}
                >
                    {props.mainImage?.url && (
                        <Image
                            data-testid="main-image"
                            borderRadius="16"
                            objectFit="cover"
                            src={props.mainImage?.url}
                            width={props.screenSize.desktop ? '240px' : '64px'}
                            height={props.screenSize.desktop ? '140px' : '64px'}
                            alt={props.mainImage?.description || ''}
                        />
                    )}
                </Box>
            </Box>
            {!props.screenSize.desktop && <Divider dividerStyle="dashed" direction="horizontal" />}
            <ScreenSize.NonDesktop condition={shouldShowBadges}>
                <Box display="flex" pt="8" justifyContent="flex-start">
                    <KeyAttributeBadgesNodeComponent badges={badges} activityId={props.activityId} />
                </Box>
            </ScreenSize.NonDesktop>
            {!props.screenSize.desktop && (
                <Box my="16">
                    <TextLink data-testid="activities-see-more-details" label={props.cms[411656]} textVariant="body-s" onClick={props.showSeeDetailsOverlay} />
                </Box>
            )}
        </Box>
    );
};

DetailTitleWithThumbnail.displayName = 'DetailTitleWithThumbnail';

export default connect(mapStateToProps, mapDispatchToProps)(DetailTitleWithThumbnail);
